import React from 'react';
import {
  Box,
} from '@mui/material';
import { VaultContents } from '../shared/VaultContents';
import { createIceSurface } from '../../theme/surfaces';

interface ManageWarbandVaultTabProps {
  vaultModalOpen: boolean;
  onVaultModalClose: () => void;
}

export const ManageWarbandVaultTab: React.FC<ManageWarbandVaultTabProps> = ({ vaultModalOpen, onVaultModalClose }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, ...createIceSurface(200, { icicles: true, card: true }) }}  p={1.5}>
      {/* Vault Section */}
      <VaultContents vaultModalOpen={vaultModalOpen} onVaultModalClose={onVaultModalClose} />
    </Box>
  );
};
